import {type FunctionalComponent, h} from '@stencil/core';


export interface GenericCardDescription {
    description: string;
}

export const GenericCardDescription: FunctionalComponent<GenericCardDescription> = (props) => {
    const {description} = props;

    return (description ? <p class='result-card__description'>
      <span class='result-card__description-text' innerHTML={description}/>
    </p> : '');

};
